module.exports = {
      id: "user-usage",
      viewBox: "0 0 496 512",
      url: "/" + "sprite-d3510a915c790cce9510dd41eb326371.svg#user",
      toString: function () {
        return this.url;
      }
    }